import BaseOnboarding from 'onboarding/onboardings/baseonboarding';
import AccountSidebarTree
  from 'onboarding/onboardings/AccountsListOnboarding/steps/AccountSidebarTree';
import AccountTypesStep from 'onboarding/onboardings/AccountsListOnboarding/steps/AccountTypesStep';
import AccountTypesExampleStep from 'onboarding/onboardings/AccountsListOnboarding/steps/AccountTypesExampleStep';
import AccountMenuStep from 'onboarding/onboardings/AccountsListOnboarding/steps/AccountMenuStep';
import AccountTableStep from 'onboarding/onboardings/AccountsListOnboarding/steps/AccountTableStep';
import router from 'router';
import {forceExpandSidebar} from 'onboarding/utils/sidebar';
import appEventBus from 'appEventBus';
import tracker from 'tracking';


class AccountsListOnboarding extends BaseOnboarding {
  static get name () {
    return 'accounts-list-onboarding';
  }

  static get trackingName () {
    return 'onboarding_accounts_series_2';
  }

  static async checkCondition () {
    const route = router.currentRoute;
    const routeName = route.name;

    return routeName === 'account' || routeName === 'projectsList' || routeName === 'accountView' || routeName === 'accounts';
  }

  steps () {
    return [
      {
        target: '#page-layout-sidebar .sidebar-item_active',
        attachToHighlight: true,
        header: 'Теперь вы внутри аккаунта',
        component: AccountSidebarTree,
        params: {
          placement: 'right',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar .sidebar-item_active',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        },
        events: {
          on () {
            forceExpandSidebar.on();
          },
          off () {
            forceExpandSidebar.off();
          }
        }
      },
      {
        target: '#page-layout-sidebar .sidebar-item_active',
        attachToHighlight: true,

        header: 'Есть 2 типа аккаунтов',
        component: AccountTypesStep,
        params: {
          placement: 'right',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar .sidebar-item_active',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '#page-layout-sidebar .sidebar-item_active',
        attachToHighlight: true,

        header: 'Покажу на примере',
        component: AccountTypesExampleStep,
        params: {
          placement: 'right'
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar .sidebar-item_active',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '.header-tabs__tabs .tabs',
        attachToHighlight: true,

        header: 'Меню',
        component: AccountMenuStep,
        params: {
          placement: 'bottom'
        },
        width: '408px',
        highlightTarget: '.header-tabs__tabs .tabs',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 10,
          maskSizeOffsetY: 10
        }
      },
      {
        target: '.m-table',
        attachToHighlight: true,

        header: 'Таблица',
        component: AccountTableStep,
        params: {
          placement: 'bottom'
        },
        width: '408px',
        highlightTarget: '.accounts-table',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 10,
          maskSizeOffsetY: 10
        },
        events: {
          off: () => {
            window.ymReachGoal('ONBOARDING_ACCOUNTS_COMPLETE');
            tracker.track('onboarding_accounts_complete', this.trackingParams);
            appEventBus.$emit('AUTORUN_ONBOARDING_COMPLETE');
          }
        }
      }
    ];
  }
}

export default AccountsListOnboarding;
